//User Authentication
export const LOGIN_ERROR =
  'The password or email address entered were incorrect. Please try again or click the "?" to reset your password.';
export const LOGIN_UNAUTHORIZED = 'This account is not authorized.';
export const LOGIN_INVALID_EMAIL = 'Please enter a valid email address';
export const REQUEST_DEMO_SUCCESS = "Thank you for your interest! We'll contact you shortly.";
export const RESET_PASSWORD_ERROR =
  'There was an error in resetting your password. Please make sure you entered the correct e-mail address.';
export const CHANGE_PASSWORD_ERROR = 'There was an error changing your password.';
export const SET_PASSWORD_ERROR =
  'There was an error in changing your password. Please make sure you are not reusing a recent password.';

//Impersonation
export const IMPERSONATION_ERROR =
  'Impersonation attempt failed. Please make sure you have impersonation rights.';

//Users
export const GET_USERS_ERROR = 'Failed to retrieve the list of users.';

//Tooltips
export const TOOLTIP_TEXT_ADD_DATA_SOURCE = 'Create New Data Source';

//Default page content
export const DEFAULT_TITLE_VIEW_DATA_SOURCE =
  'Add your first Data Source! Click on the + icon above to get started.';

//Tooltips

//General API access error
